import { app } from '../resources/gcp-config';
import { collection, addDoc, getFirestore, doc, deleteDoc } from 'firebase/firestore';
import { errorAlert, successAlert } from '../components/alerts';

const db = getFirestore(app);

export const saveSentEmail = async (emailData) => {
  console.log("function called", emailData)
  try {
    const docRef = await addDoc(collection(db, 'sent-emails'), emailData);
    console.log('Document written with ID: ', docRef.id);
    return docRef.id;
  } catch (e) {
    console.error('Error adding document: ', e);
    return null;
  }
};

export const deleteSentEmail = async (emailId) => {
    try {
        await deleteDoc(doc(db, 'sent-emails', emailId));
        successAlert('Success!', 'Email has been deleted.');
    } catch (error) {
        console.error('Error deleting Email:', error);
        errorAlert('Error!', 'An error occurred while deleting the Email.');
    }
} 